import DM from 'DM';
import {isMobile} from "../utils/device-detect";

const MethodType = {
    POST: 'post',
    BEACON: 'beacon'
};

export default class ViewsLogger {
    constructor({ batchSize = 0, name = 'logger' }) {
        this.name = name;
        this.batch = [];
        this.batchSize = batchSize;

        this.addEvents();
    }

    addEvents() {
        const events = ['beforeunload', 'pagehide'];

        events.forEach((eventName) => {
            window.addEventListener(eventName, () => {
                if (this.batch.length > 0) {
                    this.sendBatch(MethodType.BEACON);
                }
            }, false);
        });
    }

    logPageView() {
        const message = JSON.stringify(this.getModel());
        const data = { lg: [{ m: message, n: '' }] };
        this.sendPost(data);
    }

    logProductView({ productId, position, source, adsTrack }) {
        const model = this.getModel();
        const message = JSON.stringify({
            ...model,
            ...{
                p: productId,
                pp: position,
                s: source
            }
        });
        this.batch.push({ m: message, n: this.name });

        if (this.batch.length >= this.batchSize) {
            this.sendBatch(MethodType.POST);
        }
        if (adsTrack) {
            let trackObj = JSON.parse(decodeURIComponent(adsTrack));
            trackObj.bidRequestID = DM.Boot.ProductListPage.bidRequestId;
            trackObj.pvid = DM.Boot.ProductListPage.pvid;
            trackObj.slotID = position;
            trackObj.prods = DM.Config.productsOnListingCount;
            trackObj.domodiView = 'listing';
            if(isMobile()){
                trackObj.cols = DM.Config.productsListingColumnCountMobile;
            }else{
                trackObj.cols = DM.Config.productsListingColumnCountDesktop;
            }

            WP.stat.wave(DM.Config.WP.waveViewsEventAction, trackObj, DM.Config.WP.waveViewsEventType);
        }
    }

    sendBatch(method) {
        const methods = {
            post: this.sendPost,
            beacon: this.sendBeacon
        };

        const data = {
            lg: this.batch.splice(0, this.batch.length)
        };

        if (Object.prototype.hasOwnProperty.call(methods, method)) {
            if ('requestIdleCallback' in window && method === MethodType.POST) {
                window.requestIdleCallback(() => {
                    methods[method].apply(this, [data]);
                }, { timeout: 2000 });
            } else {
                methods[method].apply(this, [data]);
            }
        }
    }

    sendPost(data, callback = () => { }, async = true) {
        const client = new XMLHttpRequest();
        client.open('POST', DM.Config.Jsn.url, async);
        client.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
        client.onreadystatechange = (request) => {
            if (request.readyState === 4 && request.status === 200) {
                callback(request.responseText);
            }
        };

        client.send(JSON.stringify(data));
    }

    sendBeacon(data) {
        if ((window.navigator && 'sendBeacon' in window.navigator)) {
            window.navigator.sendBeacon(DM.Config.Jsn.url, JSON.stringify(data));
        } else {
            this.sendPost(data, null, false);
        }
    }

    getModel() {
        const config = DM.Config.Redirect;

        return {
            c: config.categoryId,
            vc: config.virtualCategoryId,
            ur: config.urlId,
            tg: config.tags,
            u: DM.Utils.getCookie('domodiCookies'),
            h: window.location.href,
            r: document.referrer,
            l: DM.Utils.getCookie('l'),
            ev: config.sessionExperimentVariationLabel,
            lg: config.listingGenerationId,
            t: config.timestamp,
            im: DM.Config.isMobile
        };
    }
}

